const test = (() => {

  const pageTest = document.getElementById('pageTest');
  if (pageTest) {

    let jsChakaBox = document.getElementById('jsChakaBox');
    let jsChakaI = jsChakaBox.querySelector('i');
    let jsChakaDiv = jsChakaBox.querySelector('div');

    const classChange = (name) => {
      jsChakaI.className = name
    }
    // const classStop = (onOff) => {
    //   if(onOff == 'on'){
    //     jsChakaDiv.classList.add('stop')
    //   }
    // }

    const moveRdown = () => {
      classChange('r-down')
      setTimeout(classChange, 3000, 'r-down stop')
      setTimeout(moveRup, 5000)
    }
    
    const moveRup = () => { 
      classChange('r-up')
      setTimeout(classChange, 3000, 'r-up stop')
      setTimeout(moveLdown, 5000)
    }
    const moveLdown = () => { 
      classChange('l-down')
      setTimeout(classChange, 3000, 'l-down stop')
      setTimeout(moveLup, 5000)
    }
    const moveLup = () => {
      classChange('l-up')
      setTimeout(classChange, 3000, 'l-up stop')
      setTimeout(moveRdown, 5000)
     }
    


    moveRdown()
    // document.addEventListener("DOMContentLoaded", () => {
    //   setTimeout(startFunc, 100)
    // });


  }

})();
export default test;